import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useCreateDeclaracionSituacionActividad = () => {
  const [loadingCreateDeclaracionSituacionActividad, setLoadingCreateDeclaracionSituacionActividad] = useState(false);
  const [successCreateDeclaracionSituacionActividad, setSuccessCreateDeclaracionSituacionActividad] = useState(false);
  const [errorCreateDeclaracionSituacionActividad, setErrorCreateDeclaracionSituacionActividad] = useState(null);
  const [dataCreateDeclaracionSituacionActividad, setDataDeclaracionSituacionActividad] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // CREATE
  const createDeclaracionSituacionActividad = async (
    userId: string,
    prestacionId: string,
    data: any,
    _cb?: (data: any) => void
  ) => {
    setLoadingCreateDeclaracionSituacionActividad(true);
    setSuccessCreateDeclaracionSituacionActividad(false);
    setErrorCreateDeclaracionSituacionActividad(null);

    apiRecord.newDeclaracionSituacionActividadIt(userId, prestacionId, data)
      .then((res: any) => {
        setLoadingCreateDeclaracionSituacionActividad(false);
        setSuccessCreateDeclaracionSituacionActividad(true);
        setDataDeclaracionSituacionActividad(res.data);
        _cb?.(res.data);
      })
      .catch((err: any) => {
        console.log(err);
        setLoadingCreateDeclaracionSituacionActividad(false);
        setErrorCreateDeclaracionSituacionActividad(err.response?.data);
      });
  };

  return {
    createDeclaracionSituacionActividad,
    loadingCreateDeclaracionSituacionActividad,
    successCreateDeclaracionSituacionActividad,
    errorCreateDeclaracionSituacionActividad,
    dataCreateDeclaracionSituacionActividad
  };
};

export default useCreateDeclaracionSituacionActividad;
